import { render, staticRenderFns } from "./cocal-share-dialog.vue?vue&type=template&id=688ed5ce&"
import script from "./cocal-share-dialog.vue?vue&type=script&lang=js&"
export * from "./cocal-share-dialog.vue?vue&type=script&lang=js&"
import style0 from "./cocal-share-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports